import { ApiError } from '@/services/api/ApiError'

/**
 * A request 401'd and the session couldn't be renewed because the refresh
 * endpoint was unreachable (offline, network error, timeout, 5xx). The session
 * is kept, so this is transient: mutations retry it (see `main.tsx`) rather
 * than fail, which keeps a replayed offline write queued.
 */
export class SessionUnreachableError extends ApiError {
  constructor() {
    super("Couldn't reach the server to renew your session. Please check your connection.", 0)
    this.name = 'SessionUnreachableError'
  }
}
